<template>
  <div id="candidate_resume.is_married" class="row mx-0 px-3 py-4 border-top">
    <div class="input-group row pe-0">
      <div
        class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
      >
        <label class="size-12" for="">配偶者</label>
        <span class="tag-thirdly size-10 ms-2">必須</span>
      </div>
      <div class="row p-0">
        <div class="col-6 col-md-4 pe-0">
          <Field
            v-slot="{}"
            v-model="additionalStore.is_married"
            name="candidate_resume.is_married"
          >
            <div class="form-check bg-grey-05 ps-5 p-0d8 rounded-3">
              <input
                id="is-married-true"
                class="ms-0 input-primary form-check-input radio-primary-input w-1d5 h-1d5 me-3"
                type="radio"
                name="candidate_resume.is_married"
                value="yes"
                :checked="additionalStore.is_married === 'yes'"
                @change="onChangeMarried"
              />
              <label class="form-check-label form-check-label-base pt-1" for="is-married-true">
                有り
              </label>
            </div>
          </Field>
        </div>
        <div class="col-6 col-md-4 pe-0">
          <Field
            v-slot="{}"
            v-model="additionalStore.is_married"
            name="candidate_resume.is_married"
          >
            <div class="form-check bg-grey-05 ps-5 p-0d8 rounded-3">
              <input
                id="is-married-false"
                class="ms-0 input-primary form-check-input radio-primary-input w-1d5 h-1d5 me-3"
                type="radio"
                name="candidate_resume.is_married"
                value="no"
                :checked="additionalStore.is_married === 'no'"
                @change="onChangeMarried"
              />
              <label class="form-check-label form-check-label-base pt-1" for="is-married-false">
                無し
              </label>
            </div>
          </Field>
        </div>
        <ErrorMessage name="candidate_resume.is_married" class="invalid-feedback" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAdditionalStore } from '@/stores/resume-candidate/Additional.store';
import { Field, ErrorMessage } from 'vee-validate';

const additionalStore = useAdditionalStore();

const onChangeMarried = (event: Event): void => {
  const target = event.target as HTMLInputElement;
  additionalStore.is_married = target.value;
};
</script>
